import { render } from "./PianoPerformance.vue?vue&type=template&id=652e58c5&scoped=true"
import script from "./PianoPerformance.vue?vue&type=script&lang=js"
export * from "./PianoPerformance.vue?vue&type=script&lang=js"

import "./PianoPerformance.vue?vue&type=style&index=0&id=652e58c5&lang=scss&scoped=true"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652e58c5"]])

export default __exports__